import { application } from "./application"

import AnalyticsController from "./analytics_controller"
import EnableSubmitController from "./enable_submit_controller"
import FlapController from "./flap_controller"
import FilterItemsController from "./filter_items_controller"
import FramePollingController from "./frame_polling_controller"
import MediaCompressorController from "./media_compressor_controller"
import MediaConverterController from "./media_converter_controller"
import MediaTrimmerController from "./media_trimmer_controller"
import ResetModalController from "./reset_modal_controller"
import RevealController from "./reveal_controller"
import SelectController from "./select_controller"
import ShareController from "./share_controller"
import ToolUploaderController from "./tool_uploader_controller"

application.register("analytics", AnalyticsController)
application.register("enable-submit", EnableSubmitController)
application.register("flap", FlapController)
application.register("filter-items", FilterItemsController)
application.register("frame-polling", FramePollingController)
application.register("media-compressor", MediaCompressorController)
application.register("media-converter", MediaConverterController)
application.register("media-trimmer", MediaTrimmerController)
application.register("reset-modal", ResetModalController)
application.register("reveal", RevealController)
application.register("select", SelectController)
application.register("share", ShareController)
application.register("tool-uploader", ToolUploaderController)
